import React, { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter, MemoryRouter, Routes, Route, Navigate, useParams } from "react-router";
import Home from "./pages/Home/Home";
import SEO from "./components/SEO/SEO"; 
import "./styles/App.scss";

const supportedLanguages = ["en", "fr", "de", "es", "zh", "ru", "jp", "kr", "it", "pl", "pt", "tr"];
const defaultLanguage = "en";

const LanguageContext = createContext();

const LanguageWrapper = ({ children }) => {
    const { lang } = useParams();
    const { setLanguage } = useContext(LanguageContext);

    useEffect(() => {
        if (!supportedLanguages.includes(lang)) {
            return <Navigate to={`/${defaultLanguage}`} replace />;
        }
        setLanguage(lang);
        localStorage.setItem("selectedLanguage", lang);
    }, [lang, setLanguage]);

    return children;
};

// ✅ Ajoute un paramètre `routerType` pour tester sans `BrowserRouter`
function App({ routerType = "browser" }) {
    const [language, setLanguage] = useState(localStorage.getItem("selectedLanguage") || defaultLanguage);

    const RouterComponent = routerType === "memory" ? MemoryRouter : BrowserRouter; // ✅ Permet d'utiliser MemoryRouter en test

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            <RouterComponent initialEntries={["/en"]}>
                <Routes>
                    <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />
                    <Route 
                        path="/:lang" 
                        element={
                            <LanguageWrapper>
                                <SEO /> 
                                <Home />
                            </LanguageWrapper>
                        } 
                    />
                    <Route path="*" element={<Navigate to={`/${defaultLanguage}`} replace />} />
                </Routes>
            </RouterComponent>
        </LanguageContext.Provider>
    );
}

export { LanguageContext };
export default App;
